<style scoped>
.v-application .display-2 {
  font-size: 2.2rem !important;
  font-family: "Prompt", sans-serif !important;
}
.v-application .display-1 {
  font-size: 1.8rem !important;
  font-family: "Prompt", sans-serif !important;
}
.v-application .headline {
  font-size: 1.2rem !important;
  font-family: "Prompt", sans-serif !important;
}
.v-list-item {
  padding: 0 5px !important;
}
</style>

<template>
  <div>
    <menuBar></menuBar>
    <v-layout class="mx-6 mb-n5">
      <v-row>
        <v-col cols="12" lg="4">
          <v-select
            :items="items"
            v-model="year"
            label="เลือกปี"
            dense
            outlined
            @change="all_customer()"
          ></v-select>
        </v-col>
      </v-row>
    </v-layout>

    <v-layout class="mx-6">
      <!-- การ์ดจำบอกจำนวน -->
      <v-row>
        <v-col cols="12" lg="4">
          <v-card color="#3949AB" dark>
            <v-container>
              <v-card-text>
                <v-row align="center" class="my-n2">
                  <v-col class="display-2" cols="8">{{ allcustomer }}</v-col>
                  <v-col cols="4">
                    <div class="display-1">แห่ง</div>
                  </v-col>
                </v-row>
              </v-card-text>
              <v-divider class="mb-2" style="border-color: white"></v-divider>
              <v-list-item two-line>
                <v-list-item-content>
                  <v-list-item-title class="headline"
                    >จำนวนสถานบริการที่ลงทะเบียน</v-list-item-title
                  >
                  <v-list-item-subtitle
                    >ข้อมูลวันที่ {{ today }}</v-list-item-subtitle
                  >
                </v-list-item-content>
                <v-list-item-avatar style="width: 100px; border-radius: unset">
                  <v-btn text @click="drilldown()">
                    ดูเพิ่มเติม
                    <v-icon class="white--text">mdi-chevron-right</v-icon>
                  </v-btn>
                </v-list-item-avatar>
              </v-list-item>
            </v-container>
          </v-card>
        </v-col>
        <v-col cols="12" lg="4">
          <v-card color="#2196F3" dark>
            <v-container>
              <v-card-text>
                <v-row align="center" class="my-n2">
                  <v-col class="display-2" cols="9">{{ walkoutweight }}</v-col>
                  <v-col cols="3">
                    <div class="display-1">ตัน</div>
                  </v-col>
                </v-row>
              </v-card-text>
              <v-divider class="mb-2" style="border-color: white"></v-divider>
              <v-list-item two-line>
                <v-list-item-content>
                  <v-list-item-title class="headline"
                    >ปริมาณมูลฝอยติดเชื้อที่เกิดขึ้น</v-list-item-title
                  >
                  <v-list-item-subtitle
                    >ข้อมูลวันที่ {{ today }}</v-list-item-subtitle
                  >
                </v-list-item-content>
                <v-list-item-avatar style="width: 100px; border-radius: unset">
                  <v-btn text @click="drilldown()">
                    ดูเพิ่มเติม
                    <v-icon class="white--text">mdi-chevron-right</v-icon>
                  </v-btn>
                </v-list-item-avatar>
              </v-list-item>
            </v-container>
          </v-card>
        </v-col>
        <v-col cols="12" lg="4">
          <v-card color="#FB8C00" dark>
            <v-container>
              <v-card-text>
                <v-row align="center" class="my-n2">
                  <v-col class="display-2" cols="9">{{ destroyweight }}</v-col>
                  <v-col cols="3">
                    <div class="display-1">ตัน</div>
                  </v-col>
                </v-row>
              </v-card-text>
              <v-divider class="mb-2" style="border-color: white"></v-divider>
              <v-list-item two-line>
                <v-list-item-content>
                  <v-list-item-title class="headline"
                    >ปริมาณมูลฝอยติดเชื้อที่ได้รับกำจัด</v-list-item-title
                  >
                  <v-list-item-subtitle
                    >ข้อมูลวันที่ {{ today }}</v-list-item-subtitle
                  >
                </v-list-item-content>
                <v-list-item-avatar style="width: 100px; border-radius: unset">
                  <v-btn text @click="drilldown()">
                    ดูเพิ่มเติม
                    <v-icon class="white--text">mdi-chevron-right</v-icon>
                  </v-btn>
                </v-list-item-avatar>
              </v-list-item>
            </v-container>
          </v-card>
        </v-col>
        <!-- <v-col cols="12" lg="3">
          <v-card color="#43A047" dark>
            <v-container>
              <v-card-text>
                <v-row align="center" class="my-n2">
                  <v-col class="display-2" cols="9">67.5</v-col>
                  <v-col cols="3">
                    <div class="display-1">%</div>
                  </v-col>
                </v-row>
              </v-card-text>
              <v-divider class="mb-2" style="border-color:white"></v-divider>
              <v-list-item two-line>
                <v-list-item-content>
                  <v-list-item-title class="headline">อัตราส่วนมูลฝอยที่ถูกกำจัด</v-list-item-title>
                  <v-list-item-subtitle>ข้อมูลวันที่ {{today}}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-container>
          </v-card>
        </v-col>-->
      </v-row>
    </v-layout>
    <!-- กราฟฟวงกลม -->
    <v-layout class="mx-6">
      <v-row>
        <v-col cols="12" lg="4">
          <v-card class="d-inline-block mx-auto">
            <v-card-text>
              <v-row align="center" class="my-n2">
                <v-col cols="12">
                  <Doughnut
                    ref="chart1"
                    :styles="myStyles"
                    :dataLabels="lb1"
                    :dataSet="d1"
                  ></Doughnut>
                </v-col>
              </v-row>
            </v-card-text>
            <v-divider class="mb-2" style="border-color: white"></v-divider>
            <v-list-item two-line>
              <v-list-item-content>
                <v-list-item-title class="headline">
                  ปริมาณมูลฝอยติดเชื้อ แยกตามประเภทแหล่งกำเนิด
                </v-list-item-title>
                <v-list-item-subtitle
                  >ข้อมูลวันที่ {{ today }}</v-list-item-subtitle
                >
              </v-list-item-content>
            </v-list-item>
          </v-card>
        </v-col>
        <v-col cols="12" lg="4">
          <v-card class="d-inline-block mx-auto">
            <v-card-text>
              <v-row align="center" class="my-n2">
                <v-col cols="12">
                  <Doughnut
                    ref="chart2"
                    :styles="myStyles"
                    :dataLabels="lb2"
                    :dataSet="d2"
                  ></Doughnut>
                </v-col>
              </v-row>
            </v-card-text>
            <v-divider class="mb-2" style="border-color: white"></v-divider>
            <v-list-item two-line>
              <v-list-item-content>
                <v-list-item-title class="headline">
                  ปริมาณมูลฝอยติดเชื้อ จำแนกตามประเภท
                </v-list-item-title>
                <v-list-item-subtitle
                  >ข้อมูลวันที่ {{ today }}</v-list-item-subtitle
                >
              </v-list-item-content>
            </v-list-item>
          </v-card>
        </v-col>
        <v-col cols="12" lg="4">
          <v-card class="d-inline-block mx-auto">
            <v-card-text>
              <v-row align="center" class="my-n2">
                <v-col cols="12">
                  <Doughnut
                    ref="chart3"
                    :styles="myStyles"
                    :dataLabels="lb3"
                    :dataSet="data3"
                  ></Doughnut>
                </v-col>
              </v-row>
            </v-card-text>
            <v-divider class="mb-2" style="border-color: white"></v-divider>
            <v-list-item two-line>
              <v-list-item-content>
                <v-list-item-title class="headline">
                  ปริมาณมูลฝอยติดเชื้อที่ได้รับการกำจัด
                  จำแนกตามสถานที่กำจัด</v-list-item-title
                >
                <v-list-item-subtitle
                  >ข้อมูลวันที่ {{ today }}</v-list-item-subtitle
                >
              </v-list-item-content>
            </v-list-item>
          </v-card>
        </v-col>
      </v-row>
    </v-layout>
    <!-- กราฟเส้นน -->
    <v-layout class="mx-6">
      <v-row>
        <v-col cols="12" lg="12">
          <v-card>
            <v-card-text>
              <v-row align="center" class="my-n2">
                <v-col class="display-2" cols="12">
                  <LineChart
                    :Labels="line_lable1"
                    :DataSet="line_data1"
                  ></LineChart>
                </v-col>
              </v-row>
            </v-card-text>
            <v-divider class="mb-2" style="border-color: white"></v-divider>
            <v-list-item two-line>
              <v-list-item-content>
                <v-list-item-title class="headline">
                  ปริมาณมูลฝอยติดเชื้อและปริมาณการกำจัด รายเดือน
                </v-list-item-title>
                <v-list-item-subtitle
                  >ข้อมูลวันที่ {{ today }}</v-list-item-subtitle
                >
              </v-list-item-content>
            </v-list-item>
          </v-card>
        </v-col>
      </v-row>
    </v-layout>
  </div>
</template>

<script>
import menuBar from "../components/menuBar";
import Doughnut from "../components/DoughnutChart";
import LineChart from "../components/LineChart";
import randomColor from "randomcolor";
export default {
  name: "FrontDashboard",
  components: {
    menuBar,
    Doughnut,
    LineChart,
  },
  data() {
    return {
      line_lable1: [
        "ม.ค.",
        "ก.พ.",
        "มี.ค.",
        "เม.ย.",
        "พ.ค.",
        "มิ.ย.",
        "ก.ค.",
        "ส.ค.",
        "ก.ย.",
        "ต.ค.",
        "พ.ย.",
        "ธ.ค.",
      ],
      line_data1: [
        {
          label: "ปริมาณมูลฝอย",
          data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
          borderColor: "rgba(75, 192, 192, 1)",
          backgroundColor: "rgba(75, 192, 192, 0.2)",
        },
        {
          label: "ปริมาณมูลฝอยถูกกำจัด",
          data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
          borderColor: "rgba(192, 192, 192, 1)",
          backgroundColor: "rgba(192, 192, 192, 0.2)",
        },
      ],
      items: [2563, 2564, 2565, 2566],
      lb1: [],
      d1: [
        {
          backgroundColor: [],
          data: [],
        },
      ],
      lb2: [],
      d2: [
        {
          backgroundColor: [],
          data: [],
        },
      ],
      lb3: [],
      data3: [
        {
          backgroundColor: [],
          data: [],
        },
      ],

      height: 250,
      allcustomer: 0,
      year: null,
      walkoutweight: 0,
      destroyweight: 0,
      today: "",
    };
  },
  created() {
    this.all_customer();
    this.list_all_customer();
    this.all_walkout_weight();
    this.list_all_walkout_weight();
    this.all_destroy_weight();
    this.list_all_destroy_weight();

    this.list_month_walkout_weight();
    this.list_month_destroy_weight();
    let d = new Date();
    this.today =
      d.toLocaleDateString() +
      " " +
      d.getHours() +
      ":" +
      d.getMinutes() +
      " น.";
  },
  computed: {
    lineStyle() {
      return {
        "background-color": "grey",
      };
    },
    myStyles() {
      return {
        height: `${this.height}px`,
        position: "relative",
      };
    },
  },
  methods: {
    drilldown() {
      this.$router.push({ path: "/DrillDown" });
    },
    all_customer() {
      this.$guest_api
        .post("/all-customer", {
          year: this.year,
        })
        .then((response) => {
          this.allcustomer = response.data.data[0].amount;
        })
        .catch((err) => {
          this.$swal("เกิดข้อผิดพลาด", "ลองใหม่อีกครั้ง", "error");
        });
    },
    async list_all_customer() {
      await this.$guest_api
        .post("/list-all-customer", {
          year: this.year,
        })
        .then((response) => {
          console.log(response.data);
          response.data.data.forEach((element) => {
            if (element.CUSTOMER_TYPE) {
              this.lb1.push(element.CUSTOMER_TYPE);
              this.d1[0].data.push(element.amount);
              this.d1[0].backgroundColor.push(randomColor());
            }
          });
          this.$refs.chart1.update();
        })
        .catch((err) => {});
    },
    async all_walkout_weight() {
      await this.$guest_api
        .post("/all-walkout-weight", {
          year: this.year,
        })
        .then((response) => {
          console.log(response.data);
          this.walkoutweight = (
            response.data.data[0].walkoutweight / 1000
          ).toFixed(2);
        })
        .catch((err) => {});
    },
    async list_all_walkout_weight() {
      await this.$guest_api
        .post("/list-all-walkout-weight", {
          year: this.year,
        })
        .then((response) => {
          console.log(response.data);
          response.data.data.forEach((element) => {
            this.lb2.push(element.TYPE_NAME);
            this.d2[0].data.push(element.walkoutweight);
            this.d2[0].backgroundColor.push(randomColor());
          });
          this.$refs.chart2.update();
        })
        .catch((err) => {});
    },
    async all_destroy_weight() {
      await this.$guest_api
        .post("/all-destroy-weight", {
          year: this.year,
        })
        .then((response) => {
          console.log(response.data);
          this.destroyweight = (
            response.data.data[0].destroyweight / 1000
          ).toFixed(2);
        })
        .catch((err) => {});
    },
    async list_all_destroy_weight() {
      await this.$guest_api
        .post("/list-all-destroy-weight", {
          year: this.year,
        })
        .then((response) => {
          console.log(response.data);
          response.data.data.forEach((element) => {
            this.lb3.push(element.DESTROYER_NAME);
            this.data3[0].data.push(element.destroyweight);
            this.data3[0].backgroundColor.push(randomColor());
          });
          this.$refs.chart3.update();
        })
        .catch((err) => {});
    },
    async list_month_walkout_weight() {
      await this.$guest_api
        .post("/list-month-walkout-weight", {
          year: this.year,
        })
        .then((response) => {
          console.log(response.data);
          // for (let index = 0; index < response.data.data.length; index++) {
          //   const element = response.data.data[index];
          //   if (element.month == index + 1) {
          //     this.line_data1[0].data[index] = element.walkoutweight;
          //   }
          // }
        })
        .catch((err) => {});
    },
    async list_month_destroy_weight() {
      await this.$guest_api
        .post("/list-month-destroy-weight", {
          year: this.year,
        })
        .then((response) => {
          console.log(response.data);
          for (let index = 0; index < 12; index++) {
            // const element = response.data.data[index];
            // console.log(element)
    console.log(index)

            // if (element.month == (index + 1)) {
            //   console.log('--->'+element)
            //   this.line_data1[1].data[index] = element.destroyweight;
            //   console.log(this.line_data1[1].data[index])
            // }
          }
        })
        .catch((err) => {});
    },
  },
};
</script>
